import AppsIcon from '@mui/icons-material/Apps';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Avatar from '@mui/material/Avatar';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  destroySession,
  establishOrRefreshSession
} from '../../common/sessionGate';
import { apps } from '../../services/gApps/GApps';
import { data } from '../../services/mockingData/User';
import { ITooltip, Text, reExportedColors } from '../1elements/';
import Hamburger from '../1elements/Icons/js/Hamburger';
import MapSearch from '../1elements/Icons/js/MapSearch';
import SignOut from '../1elements/Icons/js/SignOut';
import UserManagement from '../1elements/Icons/js/UserManagement';
import beeLogo from '../1elements/Icons/png/proximityLogo.png';

const MobileDrawer = styled(Drawer)({
  width: '440'
});

const LogoRow = styled(ListItem)({
  width: 250,
  height: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});

const Logo = styled('img')({
  width: 120,
  height: 'auto',
  objectFit: 'cover'
});

const navigationIconStyles = {
  marginRight: 12,
  fill: reExportedColors.DARK_GREY,
  cursor: 'pointer'
};

const ProfileAvatar = styled(Avatar)(navigationIconStyles);
const SearchIcon = styled(MapSearch)(navigationIconStyles);
const AppsMenuIcon = styled(AppsIcon)(navigationIconStyles);
const UserManagementIcon = styled(UserManagement)(navigationIconStyles);
const SignOutIcon = styled(SignOut)(navigationIconStyles);

const ProfileImage = styled('img')({
  width: 50
});

const MobileLink = styled(Link)({
  textDecoration: 'none'
});

const NavigationItem = styled(ListItemButton)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: 15
});

const AppsItem = styled(ListItemButton)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: 15
});

const AppsLabel = styled('div')({
  display: 'flex'
});

const AppsList = styled(ListItem)({
  width: 250,
  height: 'auto',
  padding: '20px 30px',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'start'
});

const AppEntry = styled('div')({
  width: 30,
  height: 30,
  margin: 15,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center'
});

const MenuTrigger = styled('div')({
  position: 'absolute',
  zIndex: 30
});

const MenuButton = styled(Hamburger)({
  position: 'absolute',
  zIndex: 30,
  padding: 10,
  marginTop: 20,
  marginRight: 8,
  marginLeft: 10,
  border: '1px solid #dbdbdb',
  borderRadius: 4,
  background: 'white'
});

export default function MobileMenu() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openAppsDrawer, setOpenAppsDrawer] = useState(false);

  const openMenu = () => {
    setOpenDrawer((currentOpen) => !currentOpen);
    establishOrRefreshSession();
  };

  const closeMenu = () => {
    setOpenDrawer((currentOpen) => !currentOpen);
    establishOrRefreshSession();
  };

  const openApps = () => {
    setOpenAppsDrawer((currentOpen) => !currentOpen);
    establishOrRefreshSession();
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
    establishOrRefreshSession();
  };

  return (
    <>
      <MobileDrawer
        anchor="left"
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
      >
        <List>
          <LogoRow>
            <Link to="/home">
              <Logo src={beeLogo} alt="logo" />
            </Link>
            <CloseIcon onClick={closeMenu} />
          </LogoRow>

          <ListItemButton divider>
            <ProfileAvatar>
              <ProfileImage src={data.initials} alt="profile" />
            </ProfileAvatar>
            <Text type="menuItem">{data.name}</Text>
          </ListItemButton>

          <MobileLink to="/home">
            <NavigationItem divider onClick={closeMenu}>
              <SearchIcon height="25" width="25" />
              <Text type="menuItem">Search</Text>
            </NavigationItem>
          </MobileLink>

          <AppsItem onClick={openApps} divider>
            <AppsLabel>
              <AppsMenuIcon height="25" width="25" />
              <Text type="menuItem">Apps</Text>
            </AppsLabel>
            {openAppsDrawer ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </AppsItem>

          {openAppsDrawer ? (
            <AppsList divider>
              {apps.map((item) => (
                <AppEntry
                  key={item.name}
                  onClick={() => openInNewTab(item.link)}
                >
                  <ITooltip content={item.name} placement="top">
                    <img
                      src={item.icon}
                      alt={item.name}
                      style={{ width: 25, height: 25 }}
                    />
                    <Text type="resizedMenuItem">{item.name}</Text>
                  </ITooltip>
                </AppEntry>
              ))}
            </AppsList>
          ) : null}

          <MobileLink to="/user-management">
            <NavigationItem divider onClick={closeMenu}>
              <UserManagementIcon height="25" width="25" />
              <Text type="menuItem">User Management</Text>
            </NavigationItem>
          </MobileLink>

          <NavigationItem divider onClick={destroySession}>
            <SignOutIcon height="25" width="25" />
            <Text type="menuItem">Log out</Text>
          </NavigationItem>
        </List>
      </MobileDrawer>

      <MenuTrigger onClick={openMenu}>
        <MenuButton height="40" width="43" />
      </MenuTrigger>
    </>
  );
}
